// extracted by mini-css-extract-plugin
export var arrows = "_28-5";
export var decrementer = "_28-9";
export var disabled = "_28-3";
export var error = "_28-1";
export var hiddenText = "_28-a";
export var incrementer = "_28-8";
export var input = "_28-7";
export var inputWrapper = "_28-0";
export var leadingIcon = "_28-b";
export var readonly = "_28-2";
export var regular = "_28-6";
export var small = "_28-4";